var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.reportId == _vm.CREPORT.TYPE.DELETED_TRANSACTIONS)?_c('DeletedTransactions',{attrs:{"data":_vm.data}}):_vm._e(),(_vm.reportId == _vm.CREPORT.TYPE.TIME_SHEETS)?_c('TimeSheets',{attrs:{"data":_vm.data}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }